import React from 'react'
import PropTypes from 'prop-types'
import GlgInlineLoadingSpinner from '../../../../shared/components/glg_loading_spinner_inline'
import {
  useGetWizardSelectedCoursesQuery,
  useGetScorecentreWizardSelectedCoursesQuery,
} from '../../../api/courses'

export const Step3MatchTees = ({
  source,
  selectedCourseId,
  selectedCourseName,
  existingCourseId,
  selectedTeeIds,
  matchedTees,
  onTeeMatch,
}) => {
  const skip = !selectedCourseId || !existingCourseId

  const { data: crsData, isLoading: crsLoading } = useGetWizardSelectedCoursesQuery(
    {
      crs_course_id: selectedCourseId,
      crs_course_name: selectedCourseName,
      existing_course_id: existingCourseId,
      ...(selectedTeeIds?.length > 0 ? { 'crs_tee_ids_to_import[]': selectedTeeIds } : {}),
    },
    { skip: source !== 'crs' || skip }
  )

  const { data: scorecentreData, isLoading: scorecentreLoading } = useGetScorecentreWizardSelectedCoursesQuery(
    {
      scorecentre_course_id: selectedCourseId,
      scorecentre_course_name: selectedCourseName,
      existing_course_id: existingCourseId,
    },
    { skip: source !== 'scorecentre' || skip }
  )

  const data = source === 'crs' ? crsData : scorecentreData
  const isLoading = source === 'crs' ? crsLoading : scorecentreLoading

  if (isLoading) {
    return (
      <div className="text-center add-margin-top-20">
        <GlgInlineLoadingSpinner show={true} />
      </div>
    )
  }

  if (!data) return null

  const { course_name, course_tees, existing_course_name, existing_course_tees } = data

  if (!course_tees?.length) {
    return (
      <p className="text-center">
        {window.I18n.t('courses.crs.wizard_page_3.course_has_no_tee', { course_name: course_name })}
      </p>
    )
  }

  return (
    <div>
      <label className="less_important_text add-margin-top-10">
        {window.I18n.t(`courses.${source}.popup.match_tees`)}
      </label>
      <div className='btsp_square_solid customer_box'>
        <div className="row">
          <div className="col-xs-5">
            <label className="pull-left">
              {window.I18n.t('courses.crs.wizard_page_3.course_from_crd')}
              <br />
              {course_name}
            </label>
          </div>
          <div className="col-xs-7">
            <label className="pull-right">
              {window.I18n.t('courses.crs.wizard_page_3.existing_course')}
              <br />
              {existing_course_name}
            </label>
          </div>
        </div>
        <div className="clear" />
        <div className="tees_match_selector">
          {course_tees.map((tee) => (
            <div key={tee.id} className="row add-margin-top-10">
              <div className="col-xs-5 add-padding-top-5">
                {tee.name}
              </div>
              <div className="col-xs-7">
                <select
                  className="select_tee_id form-control"
                  value={matchedTees[tee.id] || ''}
                  onChange={(e) => onTeeMatch(tee.id, e.target.value)}
                >
                  {existing_course_tees.map((existingTee) => (
                    <option key={existingTee.id} value={existingTee.id}>
                      {existingTee.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

Step3MatchTees.propTypes = {
  source: PropTypes.oneOf(['crs', 'scorecentre']).isRequired,
  selectedCourseId: PropTypes.string,
  selectedCourseName: PropTypes.string,
  existingCourseId: PropTypes.string,
  selectedTeeIds: PropTypes.arrayOf(PropTypes.string),
  matchedTees: PropTypes.object.isRequired,
  onTeeMatch: PropTypes.func.isRequired,
}

Step3MatchTees.defaultProps = {
  selectedTeeIds: [],
}
